import Confetti from 'react-confetti';

import { useBreakpoint } from '@hivebrite/design-system/Theme';

import {
  CANONS_VELOCITY_X,
  CANONS_VELOCITY_Y,
} from 'hb-react/frontoffice/components/SuccessConfetti/constants/canons';
import { type ConfettiPatternProps } from 'hb-react/frontoffice/components/SuccessConfetti/types';

export const CanonsPattern = ({ onConfettiComplete }: ConfettiPatternProps) => {
  const breakpoint = useBreakpoint();

  return (
    <>
      <Confetti
        width={window.innerWidth}
        height={window.innerHeight}
        gravity={0.2}
        numberOfPieces={100}
        onConfettiComplete={onConfettiComplete}
        recycle={false}
        confettiSource={{
          x: 0,
          y: window.innerHeight,
          w: 0,
          h: 0,
        }}
        initialVelocityX={CANONS_VELOCITY_X[breakpoint]}
        initialVelocityY={CANONS_VELOCITY_Y[breakpoint]}
      />
      <Confetti
        width={window.innerWidth}
        height={window.innerHeight}
        gravity={0.2}
        numberOfPieces={100}
        onConfettiComplete={onConfettiComplete}
        recycle={false}
        confettiSource={{
          x: window.innerWidth,
          y: window.innerHeight,
          w: 0,
          h: 0,
        }}
        initialVelocityX={{
          min: -CANONS_VELOCITY_X[breakpoint].min,
          max: -CANONS_VELOCITY_X[breakpoint].max,
        }}
        initialVelocityY={CANONS_VELOCITY_Y[breakpoint]}
      />
    </>
  );
};
